import { Injectable, inject } from '@angular/core';
import { ToastService } from '../../toast/services/toast.service';

@Injectable({
  providedIn: 'root',
})
export class NotImplementedYetService {
  private readonly toast = inject(ToastService);

  public showToast(): void {
    this.toast.show((builder) =>
      builder
        .initWarning('Ta funkcjonalność jest jeszcze niedostępna.')
        .build(),
    );
  }
}
